export const LAST_VISIT_KEY = 'rafa:last-visit'
export const LAST_VISIT_TTL_MS = 24 * 60 * 60 * 1000

const EXCLUDED_PATH = /^\/(?:pwa(?:-launch|\/)|students(?:\/|$)|onboarding(?:\/|$)|users(?:\/|$))/

export function isRestorablePath(path) {
  if (!path || !path.startsWith('/') || path.startsWith('//')) return false
  return !EXCLUDED_PATH.test(path)
}

export function canonicalVisitPath(location) {
  if (!isRestorablePath(location.pathname)) return null

  const params = new URLSearchParams(location.search || '')
  params.delete('open_search')
  const query = params.toString()
  return `${location.pathname}${query ? `?${query}` : ''}${location.hash || ''}`
}

export function readStoredVisit(storage, now = Date.now()) {
  let raw
  try { raw = storage.getItem(LAST_VISIT_KEY) } catch (error) { return null }
  if (!raw) return null

  let entry
  try { entry = JSON.parse(raw) } catch (error) { return null }
  if (!entry || typeof entry.path !== 'string' || typeof entry.ts !== 'number') return null
  if (now - entry.ts > LAST_VISIT_TTL_MS || !isRestorablePath(entry.path.split(/[?#]/)[0])) return null
  return entry.path
}
